import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Modal, Text } from "@pentabd/ui";

import {
  InputDateControllerVertical,
  InputTextAreaVertical,
  SelectControllerVertical,
  SelectEmployeeForExtraResponsibility,
} from "@components";

import { EXTRA_RESPONSIBILITY } from "@validations/HRM/employee/extraResponsibilityValidation";
import { extraResponsibilityTypes } from "./const";

const { TYPE, DESCRIPTION, START_DATE } = EXTRA_RESPONSIBILITY;

interface Props {
  addExtraResponsibilityModalOpen: boolean;
  onAddExtraResponsibilityClose: (id: number | null) => void;
  loading?: boolean;
}

export const AddExtraResponsibilityModal = ({
  addExtraResponsibilityModalOpen,
  onAddExtraResponsibilityClose,
  loading,
}: Props) => {
  const { t } = useTranslation();

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  return (
    <Modal
      isOpen={addExtraResponsibilityModalOpen}
      onClose={() => onAddExtraResponsibilityClose(null)}
      overlay
      closeAble
    >
      <div className="px-10 my-10 modal_width">
        <div className="border-bottom pb-5 mb-8">
          <Text component="h3" size="md">
            {t("EMPLOYEES.ADD_EXTRA_RESPONSIBILITY_MODAL_HEADING")}
          </Text>
        </div>

        <div className="d-flex flex-column gap-6 mb-10">
          <SelectControllerVertical
            label="EMPLOYEES.EXTRA_RESPONSIBILITY.FORM.TYPE"
            control={control}
            name={TYPE}
            register={{ ...register(TYPE) }}
            options={extraResponsibilityTypes(t)}
            setValue={setValue}
            required
            error={errors}
          />
          <SelectEmployeeForExtraResponsibility
            showAllEmployees
            selectAllPositions
            // showAllEmployees={
            //   watch(TYPE) === extraResponsibilityValues.ATTACHMENT
            // }
          />
          <InputTextAreaVertical
            label="EMPLOYEES.EXTRA_RESPONSIBILITY.FORM.DESCRIPTION"
            register={{
              ...register(DESCRIPTION),
            }}
            error={errors}
          />
          <InputDateControllerVertical
            control={control}
            label="EMPLOYEES.EXTRA_RESPONSIBILITY.FORM.START_DATE"
            name={START_DATE}
            register={{
              ...register(START_DATE),
            }}
            errors={errors}
            required
          />
          {/* <InputDateControllerVertical
            control={control}
            label="EMPLOYEES.EXTRA_RESPONSIBILITY.FORM.END_DATE"
            name={END_DATE}
            register={{
              ...register(END_DATE),
            }}
            errors={errors}
            required
          /> */}
        </div>

        <div className="border-top pt-5 mt-5 d-flex justify-content-end gap-6">
          <Button
            fill="outline"
            type="warning"
            size="xs"
            onClick={() => onAddExtraResponsibilityClose(null)}
            loading={loading}
          >
            {t("EMPLOYEES.CLOSE_EXTRA_RESPONSIBILITY_MODAL_TEXT")}
          </Button>
          <Button
            fill="fill"
            type="primary"
            size="xs"
            htmlType="submit"
            loading={loading}
          >
            {t("EMPLOYEES.CANCEL_EXTRA_RESPONSIBILITY_BUTTON_SAVE_TEXT")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
